export default __webpack_public_path__ + "assets/11d660392f246dc01cad57fb4bcd2260.png";